(function () {
  'use strict';

  const SELECTOR_SALE = '.price-item--sale';
  const SELECTOR_COMPARE = 's.price-item--regular';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '₹{{amount}}');
      } catch (_) {}
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function parsePriceToCents(str) {
    if (!str) return 0;
    return Math.round(parseFloat(str.replace(/[^0-9.]/g, '')) * 100) || 0;
  }

  let baseSaleCents    = 0;
  let baseCompareCents = 0;

  function captureBasePrices() {
    const saleEl    = document.querySelector(SELECTOR_SALE);
    const compareEl = document.querySelector(SELECTOR_COMPARE);
    if (saleEl)    baseSaleCents    = parsePriceToCents(saleEl.textContent.trim());
    if (compareEl) baseCompareCents = parsePriceToCents(compareEl.textContent.trim());
  }

  function getAddonCents() {
    const wrapper = document.querySelector('.certificate-addon-wrapper');
    return wrapper ? (parseInt(wrapper.dataset.addonPrice, 10) || 0) : 0;
  }

  function getAddonWrapper() {
    return document.querySelector('.certificate-addon-wrapper');
  }

  function getDisabledVariantSet(wrapper) {
    return new Set(
      (wrapper?.dataset.certificateDisabledVariants || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
    );
  }

  function getCurrentVariantId(wrapper) {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value;
    return wrapper?.dataset.currentVariantId || '';
  }

  function isAddonAllowedForCurrentVariant(wrapper) {
    if (!wrapper) return false;
    const disabledVariantSet = getDisabledVariantSet(wrapper);
    const currentVariantId = getCurrentVariantId(wrapper);
    return !disabledVariantSet.has(String(currentVariantId));
  }

  function syncAddonProperties(isChecked) {
    const wrapper = getAddonWrapper();
    if (!wrapper) return;

    wrapper.querySelectorAll('[data-addon-property]').forEach(function (input) {
      input.disabled = !isChecked;
    });
  }

  function syncAddonVisibility() {
    const wrapper = getAddonWrapper();
    if (!wrapper) return false;

    const checkbox = wrapper.querySelector('[data-addon-checkbox]');
    const addonAllowed = isAddonAllowedForCurrentVariant(wrapper);

    wrapper.hidden = !addonAllowed;

    if (!checkbox) return addonAllowed;

    if (!addonAllowed) {
      checkbox.checked = false;
    }

    checkbox.disabled = !addonAllowed;
    syncAddonProperties(addonAllowed && checkbox.checked);

    return addonAllowed;
  }

  /* ─── Update displayed prices on product page ─────────────── */
  function updatePrices(isChecked) {
    const addonCents = getAddonCents();
    const wrapper = getAddonWrapper();
    const addonAllowed = isAddonAllowedForCurrentVariant(wrapper);
    const shouldAdd = Boolean(isChecked && addonAllowed);

    const saleEl = document.querySelector(SELECTOR_SALE);
    if (saleEl) {
      saleEl.textContent = formatMoney(shouldAdd ? baseSaleCents + addonCents : baseSaleCents);
    }

    const compareEl = document.querySelector(SELECTOR_COMPARE);
    if (compareEl && baseCompareCents > 0) {
      compareEl.textContent = formatMoney(shouldAdd ? baseCompareCents + addonCents : baseCompareCents);
    }

    const label = document.querySelector('[data-addon-price-label]');
    if (label) label.textContent = '(+' + formatMoney(addonCents) + ')';
  }

  /* ─── Debounced variant change handler ────────────────────── */
  let variantChangeTimer = null;

  function onVariantInputChange() {
    clearTimeout(variantChangeTimer);
    variantChangeTimer = setTimeout(function () {
      captureBasePrices();
      const cb = document.querySelector('[data-addon-checkbox]');
      syncAddonVisibility();
      if (cb) {
        syncAddonProperties(cb.checked);
        updatePrices(cb.checked);
      }
    }, 400);
  }

  /* ─── Init ────────────────────────────────────────────────── */
  function init() {
    const wrapper = getAddonWrapper();
    const checkbox = document.querySelector('[data-addon-checkbox]');
    if (!wrapper || !checkbox) return;

    captureBasePrices();
    syncAddonVisibility();
    syncAddonProperties(checkbox.checked);
    updatePrices(checkbox.checked);

    checkbox.addEventListener('change', function () {
      syncAddonProperties(this.checked);
      updatePrices(this.checked);
    });

    document.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', onVariantInputChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
